import { render, staticRenderFns } from "./UIInput.vue?vue&type=template&id=0601e6b6&scoped=true&"
import script from "./UIInput.vue?vue&type=script&lang=js&"
export * from "./UIInput.vue?vue&type=script&lang=js&"
import style0 from "./UIInput.vue?vue&type=style&index=0&id=0601e6b6&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0601e6b6",
  null
  
)

export default component.exports